module.exports = __webpack_public_path__ + "media/svgs/line-horizontal-94227d7cf9ce2a6dcd325b10fc677524.svg";